import React from 'react';

export const ForgeUnitoServicenowDevIcon = () => {
	return (
		<svg width="24" height="24" viewBox="0 0 32 32" fill="none" xmlns="http://www.w3.org/2000/svg">
			<g clipPath="url(#clip0_3059_463)">
				<path
					d="M24 0H8C3.58172 0 0 3.58172 0 8V24C0 28.4183 3.58172 32 8 32H24C28.4183 32 32 28.4183 32 24V8C32 3.58172 28.4183 0 24 0Z"
					fill="white"
				/>
				<path
					d="M23.999 0.508057H8C3.86229 0.508057 0.508003 3.86234 0.508003 8.00006V23.9991C0.508003 28.1368 3.86229 31.4911 8 31.4911H23.999C28.1367 31.4911 31.491 28.1368 31.491 23.9991V8.00006C31.491 3.86234 28.1367 0.508057 23.999 0.508057Z"
					stroke="#0B1228"
					strokeOpacity="0.14"
					strokeWidth="1.017"
				/>
				<g clipPath="url(#clip1_3059_463)">
					<path
						fillRule="evenodd"
						clipRule="evenodd"
						d="M16.0589 6.66663C10.5048 6.66663 6 11.3442 6 17.1176C6 20.0044 7.12618 22.7842 9.1482 24.7621C9.86486 25.4571 10.9399 25.5372 11.7333 24.8958C14.2672 22.9178 17.7482 22.9178 20.2821 24.8958C21.0755 25.5105 22.1761 25.4571 22.8672 24.7354C26.8856 20.7528 27.0648 14.124 23.2511 9.90083C21.3571 7.86943 18.772 6.69335 16.0589 6.66663ZM16.0077 22.3832C13.3202 22.4634 11.0934 20.2449 11.0167 17.4384C11.0167 17.3582 11.0167 17.2513 11.0167 17.1711C11.0167 14.2844 13.2434 11.959 16.0077 11.959C18.772 11.959 20.9988 14.2844 20.9988 17.1711C21.0755 19.9776 18.9511 22.303 16.2637 22.3832C16.1613 22.3832 16.0845 22.3832 16.0077 22.3832Z"
						fill="#62D84E"
					/>
				</g>
			</g>
			<defs>
				<clipPath id="clip0_3059_463">
					<rect width="32" height="32" fill="white" />
				</clipPath>
				<clipPath id="clip1_3059_463">
					<rect width="20" height="20" fill="white" transform="translate(6 6)" />
				</clipPath>
			</defs>
		</svg>
	);
};
